import { Directive, Input } from '@angular/core';

import { BaseCtrlValueAccessorFormArrayComponent } from '@sim/form';

@Directive()
export abstract class BaseICCDFormArrayComponent<T> extends BaseCtrlValueAccessorFormArrayComponent<T> {
  @Input() context?: { TSK: 'OA' | 'F' | 'D' | 'S' | 'MI' };
}
